import React, { useState, useEffect } from "react";
import HomeSection from "../home/home";
import LandlordApproval from "../landlord-approval/main";
import PropertySection from "../properties/properties";
import LeasesSection from "../leases/leases";
import TenantsSection from "../tenants/tenants";
import MaintainanceSection from "../maintenance/maintainance";
import LandlordSection from "../all-landlord/mainLandlord";
import MainTenantSection from "../tenants/tenantsDetail/main";
import { useNavigate } from "react-router-dom";
import DetailMain from "../maintenance/maintanance-detail/detailMain";
import LandlordDetail from "../all-landlord/landlordDetail/mainDetail";
import DetailLeaseMain from "../leases/leaseDetail/main";
import MainSection from "../properties/property-detail/main";
import HelpSection from "../help-tutorial/help";
import SupportMain from "../support-staff/supportMain";
import DetailStaffMain from "../support-staff/detail-staff/detailStaffMain";
import CreateSupport from "../support-staff/create-support/createMain";
import Contactuslist from "../../contactus/Contactuslist";
import SubscriptionPayments from "../home/subscriptionPayments";
const RightSection = ({
  activeComponent,
  setActiveComponent,
  pendingLandlordsView,
  setPendingLandlordsView,
}) => {
  const navigate = useNavigate();
  const [selectedLandlord, setSelectedLandlord] = useState();
  const [seletedTenant, setSelectedTenant] = useState();
  const [recordId, setRecordId] = useState();
  const [showDetail, setShowDetail] = useState("");
  const [recordLeaseId, setLeaseRecordId] = useState();
  const [landlordDetail, setLandlordDetail] = useState();
  const [recordMainId, setRecordMainId] = useState();
  const [propertyId, setPropertyId] = useState();

  // Reset pending landlords view when activeComponent changes away from Landlords
  useEffect(() => {
    if (activeComponent !== "Landlords") {
      setPendingLandlordsView(false);
    }
  }, [activeComponent, setPendingLandlordsView]);

  const handleShowPendingLandlords = () => {
    setPendingLandlordsView(true);
    setActiveComponent("Landlords");
  };

  const handleShowAllSubscriptions = () => {
    setActiveComponent("AllSubscriptions");
  };

  const toggleDetailMaintain = () => {
    setActiveComponent("MaintainanceDetails");
  };

  const handleShowNotification = () => {
    setActiveComponent("Notifications");
  };

  const handleLandlordApproval = (item) => {
    setSelectedLandlord(item);
    setActiveComponent("LandloardApproval");
  };

  const handleShowHome = () => {
    setActiveComponent("Home"); // Set activeComponent to "Home"
  };

  const handleShowProperty = () => {
    setActiveComponent("Properties"); // Set activeComponent to "Home"
  };

  const togglePropertyDetail = (id) => {
    setPropertyId(id);
    localStorage.setItem("propertid", id);
    setActiveComponent("PropertiesDetail"); // State toggle karein
  };

  const handleShowMaintainance = () => {
    setActiveComponent("Maintenance"); // Set activeComponent to "Home"
  };

  const handleShowTenant = () => {
    setActiveComponent("Tenants"); // Set activeComponent to "Home"
  };

  const handleDetailStaff = () => {
    setActiveComponent("DetailStaff"); // Set activeComponent to "Home"
  };

  const handleCreateStaffs = () => {
    setActiveComponent("CreateStaff"); // Set activeComponent to "Home"
  };

  const handleShowTenantDetail = (tenant) => {
    setSelectedTenant(tenant);
    setActiveComponent("TenantsDetail"); // Set activeComponent to "Home"
  };

  const handleShowLandlords = () => {
    setPendingLandlordsView(false);
    setActiveComponent("Landlords");
  };

  const handleShowProfile = (item) => {
    if (item === "Change Password") {
      navigate("/reset-password");
    } else {
      setActiveComponent(item);
    }
  };

  const toggleLeaseDetail = (status, id) => {
    setShowDetail(status);
    setLeaseRecordId(id);
    setActiveComponent("detailLease"); // State toggle karein
  };

  const handleShowLandlordDetail = (item) => {
    setLandlordDetail(item);
    setActiveComponent("landlordDetail");
  };

  if (activeComponent === "LandloardApproval") {
    return (
      <LandlordApproval
        selectedLandlord={selectedLandlord}
        onBack={handleShowHome}
      />
    );
  }

  // Show the HomeSection component if activeComponent is "Home"
  if (activeComponent === "Home") {
    return (
      <HomeSection
        onNotificationClick={handleShowNotification}
        onLandlordApproval={handleLandlordApproval}
        onPropertyPage={handleShowProperty}
        onTenantList={handleShowTenant}
        onViewDetails={handleShowTenantDetail}
        onViewDetailsMaintain={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onViewDetailsLandlord={handleShowLandlordDetail}
        onMaintainanceTable={handleShowMaintainance}
        onViewDetailsProperty={togglePropertyDetail}
        detailStaff={handleDetailStaff}
        createSupport={handleCreateStaffs}
        onLandlordTable={handleShowLandlords}
        onPendingLandlordTable={handleShowPendingLandlords}
        onSubscriptionsList={handleShowAllSubscriptions}
      />
    );
  }

  // Handle other sections
  if (activeComponent === "Tenants") return <TenantsSection />;
  if (activeComponent === "PropertiesDetail")
    return (
      <MainSection
        propertyId={propertyId}
        onBack={handleShowHome}
        onViewDetailsMaintain={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onMaintainancePage={handleShowMaintainance}
        toggleLeaseDetail={toggleLeaseDetail}
      />
    );
  if (activeComponent === "landlordDetail")
    return (
      <LandlordDetail landlordInfo={landlordDetail} onBack={handleShowHome} />
    );
  if (activeComponent === "detailLease")
    return (
      <DetailLeaseMain
        onBack={handleShowHome}
        showDetailStatus={showDetail}
        recordId={recordLeaseId}
        onViewDetailsMaintain={(item) => {
          setRecordMainId(item);
          toggleDetailMaintain(item);
        }}
        onMaintainancePage={handleShowMaintainance}
      />
    );
  if (activeComponent === "TenantsDetail")
    return (
      <MainTenantSection
        seletedTenant={seletedTenant}
        onBack={handleShowHome}
        onViewMaintainDetails={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onAction={(item) => {
          handleShowProfile(item);
        }}
        toggleLeaseDetail={toggleLeaseDetail}
        onTriggerCard={handleShowProfile}
      />
    );

  if (activeComponent === "Properties")
    return <PropertySection toggleLandlordTable={handleShowLandlords} />;
  if (activeComponent === "Maintenance") return <MaintainanceSection />;
  if (activeComponent === "MaintainanceDetails")
    return <DetailMain recordId={recordId} onBack={handleShowHome} />;
  if (activeComponent === "Leases")
    return (
      <LeasesSection
        toggleMaintainanceTable={handleShowMaintainance}
        toggleLeaseDetail={toggleLeaseDetail}
        toggleLeaseTable={handleShowLandlords}
        onViewMaintainDetails={(item) => {
          setRecordMainId(item);
          toggleDetailMaintain(item);
        }}
      />
    );
  if (activeComponent === "Landlords")
    return (
      <LandlordSection
        filterByStatus={pendingLandlordsView ? "pending" : null}
      />
    );
  if (activeComponent === "Staff") return <SupportMain />;
  if (activeComponent === "DetailStaff")
    return <DetailStaffMain onBack={handleShowHome} />;
  if (activeComponent === "CreateStaff")
    return <CreateSupport onBack={handleShowHome} />;
  if (activeComponent === "Help") return <HelpSection />;
  if (activeComponent === "ContactUs") return <Contactuslist />;
  if (activeComponent === "AllSubscriptions") return <SubscriptionPayments />;

  return null; // Default case (if no activeComponent matches)
};

export default RightSection;

// {
//   "name": "Notifications",
//   "label": "Notifications",
//   "image": "/assets/daashboard/notification.png"
// },
// {
//   "name": "Broadcasts",
//   "label": "Broadcasts",
//   "image": "/assets/daashboard/broascast.png"
// },
